/**
 * Copyright (c) Mayoral Moda Infantil, S.A.U. and affiliates.
 */

import { i18n } from '@/../next-i18next.config';
import { LangIdentifiers } from '@/lib/constants';

export const DefaultLang = i18n.defaultLocale;
export const DefaultLangIdentifier = mapLocaleToLangId(i18n.defaultLocale);

/**
 * Returns the locale initial for a given locale code.
 */
export function mapLocaleToLangId(locale: string): LangIdentifiers {
  switch (locale.toLowerCase()) {
    case 'es':
      return LangIdentifiers.E;
    case 'pt':
      return LangIdentifiers.P;
    case 'en':
      return LangIdentifiers.I;
    case 'fr':
      return LangIdentifiers.F;
    case 'de':
      return LangIdentifiers.A;
    case 'gr':
      return LangIdentifiers.G;
    case 'bg':
      return LangIdentifiers.B;
    case 'cs':
      return LangIdentifiers.C;
    case 'hu':
      return LangIdentifiers.H;
    case 'it':
      return LangIdentifiers.T;
    case 'ja':
      return LangIdentifiers.J;
    case 'pl':
      return LangIdentifiers.L;
    case 'ru':
      return LangIdentifiers.R;
    case 'tr':
      return LangIdentifiers.K;
    case 'uk':
      return LangIdentifiers.U;
    case 'ro':
      return LangIdentifiers.M;
    case 'zh':
      return LangIdentifiers.X;
    default:
      if (!DefaultLangIdentifier) {
        throw new Error(
          `Locale "${locale}" does not have a language identifier. Please add it or use another locale.`,
        );
      }
      return DefaultLangIdentifier;
  }
}
